var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ControlByWebX400 {
    constructor(log) {
        this.state = {
            digitalInput1: '0',
            digitalInput2: '0',
            relay1: '0',
            relay2: '0',
            vin: '0.0',
            register1: '0',
            lat: '41.6796',
            long: '-111.8737',
            utcTime: '86669',
            timezoneOffset: '-25200',
            serialNumber: '00:0C:C8:04:E2:D3',
            minRecRefresh: '3',
        };
        this.asyncHandlers = [
            {
                path: /\/state\.json(?:\?(\S+)\s*=\s*(\S+))?/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] && match[2] && match[1] in this.state) {
                        this.state[match[1]] = match[2];
                    }
                    return this.makeResponse(req, this.state);
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            // need URL field?
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': '263',
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'application/json',
            },
            data: result,
        };
    }
}
ControlByWebX400.emulatorType = 'httpRequestEmulator';
ControlByWebX400.key = '-MsBSyMo4saney4Slkcb';
